/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ReferralRequest = {
  data: {
    recipient?: string
    type?: ReferralRequest.type
    referredToTalentpool?: number | string
    referredToCompany?: number | string
    referredToVacancy?: number | string
    companySender?: number | string
    status?: ReferralRequest.status
    code?: string
    locked?: boolean
    referredProfessional?: number | string
    professionalSender?: number | string
  }
}
export namespace ReferralRequest {
  export enum type {
    COMPANY_INVITE = 'companyInvite',
    TALENTPOOL_INVITE = 'talentpoolInvite',
    VACANCY_INVITE = 'vacancyInvite',
    PROFESSIONAL_PUBLIC = 'professionalPublic',
    COMPANY_PUBLIC = 'companyPublic',
    VACANCY_PUBLIC = 'vacancyPublic',
  }
  export enum status {
    INVITED = 'invited',
    ACCOUNT_ALREADY_CREATED = 'accountAlreadyCreated',
    ACCOUNT_CREATED = 'accountCreated',
  }
}
